define([
	"dojo/_base/declare",
	"csi/table/Widget",
], function(declare, Widget) {

	// attribute ids that should be omitted from filtering
	const _omit = {
		"Node Name:Child:Dimension1Size:0": 1,
		"Dimension2Size:Child:Dimension1Size:0": 1,
		"Dimension1Size:Child:Dimension1Size:0": 1,
		"Node Name:Child:Dimension2Size:0": 1,
		"Dimension2Size:Child:Dimension2Size:0": 1,
		"Dimension1Size:Child:Dimension2Size:0": 1
	};

	return declare(Widget, {
		/**
		 * @override
		 * Disallow some attributes
		 */
		onCustomViewAttributeOptions(options) {
			options.omitAttributeCallback = (key) => _omit[key.untypedString];
			this.inherited(arguments);
		},
	});
});